export default __webpack_public_path__ + "static/media/sms_slide9.45242aa5.jpg";